import useCountdown from '@/src/utils/useCountdown';
import { useFormatter, useTranslations } from 'next-intl';

export default function AuctionEndingDate({
  id,
  end,
}: {
  id: number;
  end: string;
}) {
  const t = useTranslations('AuctionEndingDate');
  const format = useFormatter();
  const dateTime = new Date(end);

  const date = format.dateTime(dateTime, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });

  const countDown = useCountdown(end);

  return (
    <div className='rounded-t-lg bg-brand-dark px-6 py-2 text-center text-sm uppercase text-dark'>
      <span className='font-bold'># {id}</span> |{' '}
      {countDown <= 0
        ? t.rich('endedOn', { b: (chunks) => <b>{chunks}</b>, date: date })
        : t.rich('endingDate', { b: (chunks) => <b>{chunks}</b>, date: date })}
    </div>
  );
}
